// notices.js
var DKT = DKT || {};
DKT.notices = function($, DKTUtils, DKTFavorites, actualLanguage, noticesLink, translations) {
  var fetchedNotices;
  var isNoticesPage = false;

  function commonInitialization() {
    var getAllNotices = isNoticesPage;
    var favorites = DKTFavorites.getFavorites();
    if (favorites && favorites.length > 0) {
      var alreadyRead = getAlreadyRead();
      callGetNotices(isNoticesPage, favorites, alreadyRead, getAllNotices, actualLanguage);      
      subscribeListeners();      
    } else if (isNoticesPage) {
      console.log("Recibirás avisos cuando marques favoritas");
      showNoResults();
    }
  }

  function init() {    
    if(!isNoticesPage){
      commonInitialization();
    }
  }

  function initNoticesPage() {
    isNoticesPage = true;
    commonInitialization();
  }

  function callGetNotices(closure_isNoticesPage, favorites, alreadyRead, getAllNotices, language) {
    if(closure_isNoticesPage){
      showLoading();
    }

    $.ajax({
      method: "POST",
      url: "/datosJSON/getNotices.php",
      data: {
        favorites: favorites,
        alreadyRead: alreadyRead,
        getAllNotices: getAllNotices,
        language: language
      },
      success: closure_isNoticesPage ? onSuccessNoticesPage : onSuccessGenericPage,
      error: closure_isNoticesPage ? onErrorNoticesPage : onErrorGenericPage,
      dataType: "json",
      timeout: 10000,
      cache: false
    });
  }

  function onSuccessGenericPage(data) {
    var list = document.createElement("ul");
    list.classList.add("notice-list");

    if (data && data.length > 0) {
      fetchedNotices = data;
      $(".num-avisos").addClass("activo");
      $(".avisos").text(data.length);
      data.forEach(function(item) {
        var parent = document.createElement("li");
        parent.classList.add("notice-item");

        var title = document.createElement("div");
        title.classList.add("notice-title");
        title.innerHTML = item["tamborradaName"];

        var time = document.createElement("div");
        time.classList.add("notice-time");

        var publicationDate = new Date(item["publicationTime"].replace(/-/g, "/"));
        var today = new Date();
        var timeText;

        if (DKTUtils.isSameDay(publicationDate, today)) {
          timeText = DKTUtils.getFormattedDateOnlyTime(publicationDate);
        } else {
          timeText = DKTUtils.getFormattedDateOnlyDayAndMonth(publicationDate);
        }

        time.innerHTML = timeText;

        var description = document.createElement("div");
        description.classList.add("notice-description");
        description.innerHTML = item["text"];

        if (item["link"]) {
          var link = document.createElement("a");
          link.classList.add("notice-link");
          link.innerHTML =
            '<img src="/templates/t3_bs3_blank/images/aviso-ver-mas2.png" alt="' +
            translations.seeMore +
            '" title="' +
            translations.seeMore +
            '">';
          link.href = item["link"];
        }

        parent.appendChild(title);
        parent.appendChild(time);
        parent.appendChild(description);
        if (link) {
          parent.appendChild(link);
        }
        list.appendChild(parent);
      });

      var seeAll = document.createElement("a");
      seeAll.classList.add("ver-todos");
      seeAll.href = noticesLink;
      seeAll.innerHTML = translations.seeAll;

      document.getElementsByClassName("avisos-lista")[0].appendChild(list);
      document.getElementsByClassName("avisos-lista")[0].appendChild(seeAll);
    } else {
      console.log("No se han encontrado datos de los avisos");
    }
  }

  function onErrorGenericPage(error) {
    console.log(error);
    console.log("Ocurrió un error durante la petición de los avisos");
  }

  function onSuccessNoticesPage(data) {
    var list = document.createElement("ul");
    list.classList.add("grid");

    if (data.length && data.length > 0) {
      $(".avisos").text(data.length);
      data.forEach(function(item) {
        var parent = document.createElement("li");
        parent.classList.add("grid-item");

        var title = document.createElement("div");
        title.classList.add("notice-title");
        title.innerHTML = item["tamborradaName"];

        var time = document.createElement("div");
        time.classList.add("notice-time");

        var publicationDate = new Date(item["publicationTime"].replace(/-/g, "/"));
        var today = new Date();
        var timeText;

        if (DKTUtils.isSameDay(publicationDate, today)) {
          timeText = DKTUtils.getFormattedDateOnlyTime(publicationDate);
        } else {
          timeText = DKTUtils.getFormattedDateOnlyDayAndMonth(publicationDate);
        }

        time.innerHTML = timeText;

        var description = document.createElement("div");
        description.classList.add("notice-description");
        description.innerHTML = item["text"];

        if (item["link"]) {
          var link = document.createElement("a");
          link.classList.add("notice-link");
          link.innerHTML =
            '<img src="/templates/t3_bs3_blank/images/aviso-ver-mas.png" title="' +
            translations.seeMore +
            '" alt="' +
            translations.seeMore +
            '">';
          link.href = item["link"];
        }

        parent.appendChild(title);
        parent.appendChild(time);
        parent.appendChild(description);
        if (link) {
          parent.appendChild(link);
        }
        list.appendChild(parent);
      });
      document.getElementsByClassName("avisos-container")[0].appendChild(list);
    } else {
      console.log("No hay avisos para tus tamborradas favoritas");
      showNoResults();
    }
    hideLoading();
    initalizeGrid();
  }

  function onErrorNoticesPage(error) {
    console.log(error);
    console.log("Ocurrió un error durante la petición de los avisos");
    showError();
  }

  function toggleNotices() {
    var isActive = $(".avisos-lista").hasClass("activo");

    if (isActive) {
      $(".avisos-lista").removeClass("activo");
      stopListening();
    } else {
      $(".avisos-lista").addClass("activo");
      listenDocumentToCloseNotices();
      setAlreadyRead();
    }
  }

  function listenDocumentToCloseNotices() {
    $(document).on("touchstart", function(e) {
      console.log("TOUCH");
    });

    $(document).on("click touchstart", function(e) {
      console.log("DETECTED");
      if (e.target !== $(".avisos").get(0)) {
        var noticesContainer = $(".avisos-lista");
        var isActive = $(".avisos-lista").hasClass("activo");
        if (isActive && !noticesContainer.is(e.target) && noticesContainer.has(e.target).length === 0) {
          $(".avisos-lista").removeClass("activo");
          stopListening();
        }
      }
    });
  }

  function stopListening() {
    $(document).off("click touchstart");
  }

  function subscribeListeners() {
    $(".avisos").on("click", toggleNotices);
  }

  function getAlreadyRead() {
    if (localStorage.getItem("alreadyRead")) {
      try {
        var alreadyRead = JSON.parse(localStorage.getItem("alreadyRead"));
      } catch (e) {
        console.log("No se ha podido convertir el JSON desde local storage");
        var alreadyRead = [];
      }
      return alreadyRead;
    }
    return [];
  }

  function setAlreadyRead() {
    var provisionalAlreadyRead = [];
    if (fetchedNotices.length && fetchedNotices.length > 0) {
      provisionalAlreadyRead = getAlreadyRead();

      fetchedNotices.forEach(function(item) {
        if (!isAlreadyRead(item.id)) {
          provisionalAlreadyRead.push(item.id);
        }
      });

      localStorage.setItem("alreadyRead", JSON.stringify(provisionalAlreadyRead));
    }
  }

  function isAlreadyRead(id) {
    var alreadyRead = getAlreadyRead();
    var isAlreadyRead = false;
    for (var i = 0; i < alreadyRead.length; i++) {
      if (id == alreadyRead[i]) {
        isAlreadyRead = true;
        break;
      }
    }

    return isAlreadyRead;
  }

  function initalizeGrid() {
    jQuery(".grid").masonry({
      itemSelector: ".grid-item"
    });
  }

  function showLoading() {
    $("#loading").css("display", "block");
  }

  function hideLoading() {
    $("#loading").css("display", "none");
  }

  function showNoResults() {
    var message = document.createElement("div");
    message.classList.add("alert");
    message.classList.add("alert-info");
    message.innerHTML = DKT.translations.noNotices;

    document.getElementsByClassName("avisos-container")[0].appendChild(message);
    hideLoading();
  }

  function showError() {
    var message = document.createElement("div");
    message.classList.add("alert");
    message.classList.add("alert-danger");
    message.innerHTML = DKT.translations.errorGeneric;

    document.getElementsByClassName("avisos-container")[0].appendChild(message);
    hideLoading();
  }

  return {
    init: init,
    initNoticesPage: initNoticesPage
  };
};
